/**
 * @file SPA entrypoint (T0.7).
 *
 * Order is deliberate: validate the environment BEFORE touching React. A build
 * with a malformed `VITE_API_BASE_URL` fails loudly here, at the first line of
 * the bundle, instead of rendering a shell that cannot reach its API.
 */
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "./App";
import { readWebEnv } from "./env";
import "./index.css";

// Named explicitly rather than passing `import.meta.env` wholesale: this is the
// complete list of build-time variables the bundle reads, and Vite's
// `ImportMetaEnv` index signature would otherwise hide a typo in a variable
// name (a misspelled `VITE_*` key reads as `undefined`, not as a compile error).
const env = readWebEnv({
  VITE_API_BASE_URL: import.meta.env.VITE_API_BASE_URL,
});

const container = document.getElementById("root");
if (container === null) {
  throw new Error('index.html is missing its <div id="root"> mount point.');
}

createRoot(container).render(
  <StrictMode>
    <App env={env} />
  </StrictMode>,
);
